export const ru = {
    'not-found': 'Ничего не найдено',
    'not-selected': 'Нет выбранных',
    'search-placeholder': 'Найти эксперимент или сегмент',
    'segment-targeting-disabled': 'Таргетинг по сегментам отключен',
    title: 'Таргетинг по сегментам'
};
